import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { CommonService } from '../services/common.service';
import { BaseComponent } from '../components/base/base.component';
import { subModule } from 'src/app/authentication/models/sign-in';
import { permissionTypes } from '../enums/permission';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard extends BaseComponent implements CanActivate {
  expectedRoleL1: string;
  expectedRoleL2: string;
  constructor(
    private router: Router,
    private common_service: CommonService,
  ) {
    super();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const segments = state.url.split('/').filter(segment => segment);
    [this.expectedRoleL1, this.expectedRoleL2] = segments;
    if (this.expectedRoleL2 !== 'profile' && this.expectedRoleL2 !== 'user-organizations') {
      if (this.common_service.isAuthenticated()) {
        if (this.common_service.isUserAuthenticated()) {
            if (this.checkPermission(this.expectedRoleL1, this.expectedRoleL2)) {
              return true;
            } 
            // else {
            //   this.router.navigate(['/access-denied']);
            //   return false;
            // }
        } else {
          this.router.navigate(['/authentication/user-organizations']);
          return false;
        }
      } else {
        this.router.navigate(['/authentication/signin']);
        return false;
      }
    }
    return true;
  }

  checkPermission(expectedRoleL1: string, expectedRoleL2: string): boolean {
    let hasPermission = false;
    const permissions = this.common_service.getPermissions();
    permissions?.forEach((permission: any) => {
      if (permission.name.replace(' ', '-').toLowerCase() === expectedRoleL1.toLowerCase()) {
        permission.sub_modules.forEach((sub: subModule) => {
          if (sub.sub_module_name.replace(' ', '-').toLowerCase() === expectedRoleL2.toLowerCase()) {
            if (sub.permission_type_id === permissionTypes.no_access) {
              hasPermission = false;
              return;
            } else {
              hasPermission = true;
            }
          }
        });
      }
    });
    return hasPermission;
  }
}